// SERVER
export const HOST_URL = "http://localhost:3000/";
export const BASE_URL = "https://admin.simplisell.in/api/v2/";
export const BASE_URL_AUTH = "https://admin.simplisell.in/api/v2/";
export const DEFAULT_WALL_MAP = "https://storage.simplisell.workers.dev/8373/6526ff32cf8c1_wallmap.png";
export const DEFAULT_FLOOR_MAP = "https://storage.simplisell.workers.dev/8377/652703cd1fe90_4f106d1b5cde1908c8f2ba2c074b3faf.jpg";

// DEV-LOCAL
// export const HOST_URL = "http://localhost:3000/";
// export const BASE_URL = "http://localhost:8001/";
// export const BASE_URL_AUTH = "http://localhost:8000/";
// export const DEFAULT_WALL_MAP = "5f07f740b5991623548246d7"
// export const DEFAULT_FLOOR_MAP = "5ef849c28188602a98c95524"

// API TOKEN-----------------------------------------------------------
export const TOKEN = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI5IiwianRpIjoiYWQxNGRhYjUyNjExOTg4MWNmYzgxY2IxNjM4OTRlZDc0NzA3MGNlZjIzMDIxYjY4ZDYxNjlhZDA3NjI1YzQyYTE4MTc3NmZkNDg3MjYwNDciLCJpYXQiOjE3NjE4OTU2ODYuNTk1OTMxLCJuYmYiOjE3NjE4OTU2ODYuNTk1OTMzLCJleHAiOjE3OTM0MzE2ODYuNTg4NzE3LCJzdWIiOiIyNDgiLCJzY29wZXMiOltdfQ.mhTp5gpkGC4I35UzV9x1tm-Wzi8VmkdhWDIpu4mbfncU0Og8poOelFfIKcZWfJe-sIHgZzFnkpDU1lKNYFmMy1FFzdOiKmsQcyVq_1041T3Bpj8B1stjS-VZ0hfyTZXM9fQ2kxZsDx0kST0eX1JagFeQTd_LSibjJXTQ5pB6utBc18x4jp6dpPug528pBJWxrjf8nzHr2pzpfInmm4PYTOiEcpLtqmJFwJGVSp72-x2TK49wNHWN8VHJvVM9yEFWG431s4pv2XIYgfByKjIsabKKx6SWf4CNjpyaEwJFzS31-PlDoUFPlVwAyOSPFjMR9rgDEE4yLjpCbUONV2MjVRuYRkeuKmn8j__MyQMID5iG66rwci1y36WhMOASWTM3_LPp3yD58OvY7fR-5oN4Mdk1x1dA0J0H0kjHXMp5Tjw6HXBu_CiP5HaoV-p7T3tza3AvaAwQ7dvJSCEvN44zUPw9GADuo1qahy3vW3RtmrCYrom8lyy5jEgW2DbJrRQ5pCfMElQiiR-5UmJXbtUWNAIkSkwltLDvtrt9EYlGo0Fyx1TgxblH8G4thQEgDssvW96rX2V-0gcMAwNaHSq0bhIdXvo7Thixvp3a2P0wxdUTvfn1KeLEX8qJncGiK93N19dy0EupyhAlBCn5Wu1V_bkC61GPWCRKK07Ro77hTpM";

//STORE PUBLIC LINK-----------------------------------------------------------
export const S_LINK = "f0475d6704904e0cbdf4c1cfd041a8ad";

//PLANNAR API TOKEN-----------------------------------------------------------
// export const TOKEN = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI3IiwianRpIjoiM2JlNTU2MDUxZjY2MmFhNmMwZmUyNDY2MDZlY2Y3NWE1ZWQ3MjYxZjU0ODE1ZjgxZmFhYjE1YTc0MWIyMjYzNmJjNmZmOGJiM2EyNjcwOGIiLCJpYXQiOjE3MDk3MDkxODEuMjE5OTU2LCJuYmYiOjE3MDk3MDkxODEuMjE5OTU4LCJleHAiOjE3NDEyNDUxODEuMTk3NDQxLCJzdWIiOiIyNDkiLCJzY29wZXMiOltdfQ.lYgeN7w-kjm2KA6N3uhVXEtFFwdqh1_NQt8a2aDKPgjaDMcvaTito_88d4eviGcgx8byLhVTFsezpcAvXr7iX5EkOR3N3sCuaCZ_vLSGjxiBSyuWiYriozPSDBwaG_UyLMIFHn92Jp5oSrbMuWyIjf46JtZxonujmpO6e9laOos6zTpf_skVqk1Ruhio4FQ-4wgm7WCjDWqL48FbLWfUCeekt9jsCwugjg_TucrvT3VTR5MQJapHQ0H87DeCXr63xoO8KwiJXGnbwbu5im_mXv2-NYcrSjZojJVLVSH6u8Y6l5_q2aEfCqrjvOqcH4QdwsiCsyo1kXFXrtiocE8Uo9BsgPfsPlHYYwoVX1kuZfwD9ByUMvm2PlKTuGAs6b1Xr8ddDSmGxnhtNhxJS8ut2fr2MNu2RrC_qjEPNxIbBoB86P-L8LNyHEscS8Uk6G2b2c1gIQu-AOW2XhyNTKuBE-IjGz9ef3bigCTehIxje6LwXT57xVbO4HtJiF9mb_lwEbUi8v0XuWBJYrLmQdnDWdnN5Fj2mMwXDBX0r4vAxfeuEh4KfjZep5qBKQ_f0pOw3k4w8ZVseCfTCWdjhzSxnIzou1QGukzOHEnPDAMQKsyLgfLPjSXkKdV9x0hogUdpS7TlpXy_P3XxT-xtY9p-lotADQWtSv0MumZAzUI0zCQ"

//PLANNAR STORE PUBLIC LINK-----------------------------------------------------------
// export const S_LINK = "28e374b5c6e44c86b3a71ef8eaab7c5f";

//CRYPTOJS KEY-----------------------------------------------------------
export const CRYPTOJS_KEY = "CryptKey1293";

//PABBLY WEBHOOK-----------------------------------------------------------
export const PABBLY_USER_REGISTER = "https://connect.pabbly.com/workflow/sendwebhookdata/IjU3NjUwNTY4MDYzZjA0MzM1MjZhNTUzNTUxMzci_pc";

//MIXPANEL-----------------------------------------------------------
export const MIXPANEL_PROJECT_TOKEN = "6744c65e5be2d018427114c4bc3aa328";

// ENDPOINT-----------------------------------------------------------
export const MIRRAR_PAGE_URL = "https://mirrar.in/";
export const CATALOGUE_ENDPOINT = "user/catalogues";
export const PRODUCT_ENDPOINT = "user/products";
export const PRODUCT_CATEGORIES_ENDPOINT = "user/product-categories";
export const CATEGORY_PRODUCT_ENDPOINT = "user/category-products";
export const PLANNAR_ENDPOINT = "customer/plannar";
export const PLANNAR_SHARE_ENDPOINT = "customer/view";
export const CUSTOMER_LOGIN = "customer/login";
export const CUSTOMER_REGISTER = "customer/register";

// COMMON-----------------------------------------------------------
export const API = "api/";
export const VERSION = "v2/";
export const USER = "user/";
export const CATALOGUES = "catalogues";
export const PRODUCTS = "products";
export const PLANNAR = "plannar";

export const ASSETS = "assets/";
export const MODELS = "models/";
export const FLOOR_MODELS = "floorModel/"
export const TEXTURES = "textures/";
export const RETRIEVE = "retrieve/";
export const USERS = "users/";
export const RESOURCES = "resources/";
export const FIND = "find/";
export const VIEW_MODEL = "view/"

export const REGISTER = "register";
export const LOGIN = "login";
export const SIGNUP = "signup";
export const LOGOUT = "logout";
export const UPLOAD_ASSET = "uploadAsset";
export const UPDATE_ASSET_ENTRY = "updateAssetEntry";

export const SOFA_CATEGORY = "sofa";
export const CHAIR_CATEGORY = "chair";
export const BED_CATEGORY = "bed";
export const ARCH_CATEGORY = "architectural";
export const MISC_CATEGORY = "misc";
export const KITCHEN_CATEGORY = "kitchen";
export const RUG_CATEGORY = "rug";
export const TABLE_CATEGORY = "table";
export const CABINET_CATEGORY = "cabinet";
export const CURTAIN_CATEGORY = "curtain";
export const LIGHT_CATEGORY = "light";
export const BATH_CATEGORY = "bath";
export const FLOOR_CATEGORY = "floor";
export const FLOOR_WOOD_CATEGORY = "floorWood";
export const FLOOR_MARBLE_CATEGORY = "floorMarble";
export const FLOOR_TILE_CATEGORY = "floorTile";
export const WALL_CATEGORY = "wall";
export const WALL_SOLID_CATEGORY = "solid";
export const WALL_TILE_CATEGORY = "wallTile";
export const GET_FREE_RESOURCES = "getFreeResources";
export const GET_RESOURCES = "getResources";

export const REMOVE_MODEL = "removeModel";
export const RETRIEVE_MODEL = "retrieve";
export const UPDATE_MODEL = "update";
export const PROJECT = "project/";

export const WALL_HEIGHT = "304.8";
export const WALL_THICKNESS = "15";